/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'EMERGENCY_DRILLS_ARE_UNANNOUNCED',
              'EVERY_WORKER_EVACUATES',
              'ALL_WORKERS_WITH_DISABILITIES_OR_SPECIAL_NEEDS_ARE_ASSISTED_BY_',
              'ALL_WORKERS_KNOW_THEIR_PRIMARY_EVACUATION_ROUTE_AND_THEIR_SECON',
              'FACILITY_HAS_DESIGNATED_EMERGENCY_ASSEMBLY_AREAS_MEETING_POINTS',
              'WORKERS_MEET_AT_ASSEMBLY_MEETING_POINTS',
              'ALL_POWER_IS_TURNED_OFF',
              'DOORS_AND_WINDOWS_ARE_CLOSED',
              'STAFF_MONITORS_LEADS_ARE_PRESENT_TO_LISTEN_AND_WATCH_TO_ENSURE_',
              'THERE_IS_A_SYSTEM_IN_PLACE_TO_ACCOUNT_FOR_ALL_WORKERS_DURING_AN',
              'THERE_IS_AN_ASSESSMENT_AFTER_THE_DRILL_TO_LEARN_HOW_TO_IMPROVE_',
              'EMERGENCY_DRILLS_ARE_DOCUMENTED_IN_A_WRITTEN_LOG',
              'NONE_OF_THE_ABOVE',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    does_the_fac_have_any_of_these_additional_measures_in_place_rel: valueSchema,
  },
}
